import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import Cell from './cell';
import Header from './header';
import Headers from './headers';
import { TableTreeContext } from './internal/context';
import Row from './row';
import Rows from './rows';
var Content = /*#__PURE__*/function (_Object) {
  _inherits(Content, _Object);
  var _super = _createSuper(Content);
  function Content() {
    _classCallCheck(this, Content);
    return _super.apply(this, arguments);
  }
  return _createClass(Content);
}( /*#__PURE__*/_wrapNativeSuper(Object));
/**
 * This is hard-coded here because our actual <TableTree /> has no typings
 * for its props.
 *
 * Adding types for real *might* break things so will need a little care.
 *
 * Defining it here for now lets us provide *something* without much headache.
 */
var TableTree = /*#__PURE__*/function (_Component) {
  _inherits(TableTree, _Component);
  var _super2 = _createSuper(TableTree);
  function TableTree() {
    var _this;
    _classCallCheck(this, TableTree);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super2.call.apply(_super2, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      columnWidths: []
    });
    _defineProperty(_assertThisInitialized(_this), "setColumnWidth", function (columnIndex, width) {
      var columnWidths = _this.state.columnWidths;
      if (width === columnWidths[columnIndex]) {
        return;
      }
      columnWidths[columnIndex] = width;
      _this.setState({
        columnWidths: columnWidths
      });
    });
    _defineProperty(_assertThisInitialized(_this), "getColumnWidth", function (columnIndex) {
      return _this.state && _this.state.columnWidths[columnIndex] || null;
    });
    return _this;
  }
  _createClass(TableTree, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var widths = this.props.columnWidths;
      if (widths) {
        this.setState({
          columnWidths: widths
        }); // eslint-disable-line
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        items = _this$props.items,
        label = _this$props.label,
        referencedLabel = _this$props.referencedLabel,
        shouldExpandOnClick = _this$props.shouldExpandOnClick,
        headers = _this$props.headers,
        columns = _this$props.columns,
        _this$props$columnWid = _this$props.columnWidths,
        columnWidths = _this$props$columnWid === void 0 ? [] : _this$props$columnWid,
        mainColumnForExpandCollapseLabel = _this$props.mainColumnForExpandCollapseLabel;
      var heads = headers && /*#__PURE__*/React.createElement(Headers, null, headers.map(function (header, index) {
        return (
          /*#__PURE__*/
          // eslint-disable-next-line react/no-array-index-key
          React.createElement(Header, {
            key: index,
            columnIndex: index,
            width: columnWidths[index]
          }, header)
        );
      }));
      var rows = null;
      if (columns && items) {
        rows = /*#__PURE__*/React.createElement(Rows, {
          items: items,
          render: function render(_ref) {
            var id = _ref.id,
              children = _ref.children,
              hasChildren = _ref.hasChildren,
              content = _ref.content;
            return /*#__PURE__*/React.createElement(Row, {
              itemId: id,
              items: children,
              hasChildren: hasChildren,
              shouldExpandOnClick: shouldExpandOnClick,
              mainColumnForExpandCollapseLabel: mainColumnForExpandCollapseLabel
            }, columns.map(function (CellContent, index) {
              return /*#__PURE__*/React.createElement(Cell
              // eslint-disable-next-line react/no-array-index-key
              , {
                key: index,
                columnIndex: index,
                width: columnWidths[index]
              }, /*#__PURE__*/React.createElement(CellContent, content));
            }));
          }
        });
      }
      return /*#__PURE__*/React.createElement(TableTreeContext.Provider, {
        value: {
          setColumnWidth: this.setColumnWidth,
          getColumnWidth: this.getColumnWidth
        }
      }, /*#__PURE__*/React.createElement("div", {
        role: "treegrid",
        "aria-readonly": true,
        "aria-label": label,
        "aria-labelledby": referencedLabel
      }, heads, rows, this.props.children));
    }
  }]);
  return TableTree;
}(Component);
export { TableTree as default };